
<template>
    <Header :image="Header_Image" title="Invest in Your Dreams with Mutual Funds" :description="{
      text: 'Discover a simplified, transparent, and effective way to grow your Wealth. Join thousands who trust us to navigate their Investment journey.',
      class: 'pe-md-5 me-md-5 opacity-8',
    }" mask="mask bg-gradient-dark opacity-2">
      <div class="buttons mb-4">
      
      </div>
    </Header>
    <div class="card card-body blur mx-3 mx-md-4 mt-lg-n6 mb-4 ">
        <LandingpageCards />
        <LandingSmartfolio />
        <BrokerCard />
        <Onboard />
        <LandingContactUs />
    </div>
  </template>
<script>
import Header from "@/homeComponents/Header.vue";
import HeaderImage_home from "@/assets/img/firefly-header.png";
import LandingpageCards from "@/homeComponents/LandingpageCards.vue";
import LandingSmartfolio from "@/homeComponents/LandingSmartfolio.vue";
import LandingContactUs from "@/homeComponents/LandingContactUs.vue";
import BrokerCard from "@/homeComponents/BrokerCard.vue";
import Onboard from "@/homeComponents/OnboardPage.vue";
export default {
  name: "HomePage",
  components: {
    Header,
    LandingpageCards,
    LandingSmartfolio,
    LandingContactUs,
    BrokerCard,
    Onboard
  },
  data() {
    return {
      Header_Image: HeaderImage_home,
    };
  },
}
</script>

